import React from 'react';
import { ButtonUI } from '@next-order/next-order-components';
import './index.css';

export default function SignIn({
  themeColors,
  onClick,
  userDetails,
  userLoyaltyDetails,
  onLoyaltySignUp,
}) {
  return (
    <div className='loyalty-sign-in-container'>
      {
        // userDetails && userLoyaltyDetails === null &&
        <ButtonUI
          fullWidth
          size='xl'
          rounded='xl'
          color='primary'
          extendedClassName='mb-4 border-none'
          style={{ backgroundColor: themeColors.backgroundColor }}
          fontSize='lg'
          // onClick={onLoyaltySignUp}
          onClick={(e) => {
            !userDetails ? onClick(e) : onLoyaltySignUp();
          }}
        >
          Create Account
        </ButtonUI>
      }
      {
        // !userDetails &&
        <ButtonUI
          fullWidth
          size='xl'
          rounded='xl'
          variant='text'
          color='accent'
          fontSize='lg'
          extendedClassName='bg-white text-black shadow-cw'
          // onClick={onClick ? (e) => onClick(e) : () => {}}
          onClick={(e) => {
            !userDetails ? onClick(e) : onLoyaltySignUp();
          }}
        >
          Sign In
        </ButtonUI>
      }
    </div>
  );
}
